'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$FeatureCode$() {
  this.c6L = null;
  this.c6M = false;
  this.c6J = null;
  this.c6K = false;
}
export { $c_Lpresto_types$FeatureCode$ as $c_Lpresto_types$FeatureCode$ };
$p = $c_Lpresto_types$FeatureCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$FeatureCode$;
/** @constructor */
function $h_Lpresto_types$FeatureCode$() {
}
export { $h_Lpresto_types$FeatureCode$ as $h_Lpresto_types$FeatureCode$ };
$h_Lpresto_types$FeatureCode$.prototype = $p;
$p.cI3 = (function() {
  if ((!this.c6M)) {
    this.c6L = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c6M = true;
  }
  return this.c6L;
});
$p.adr = (function() {
  if ((!this.c6K)) {
    this.c6J = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c6K = true;
  }
  return this.c6J;
});
var $d_Lpresto_types$FeatureCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$FeatureCode$, "presto.types$FeatureCode$", ({
  a03: 1,
  D: 1
}));
export { $d_Lpresto_types$FeatureCode$ as $d_Lpresto_types$FeatureCode$ };
var $n_Lpresto_types$FeatureCode$;
function $m_Lpresto_types$FeatureCode$() {
  if ((!$n_Lpresto_types$FeatureCode$)) {
    $n_Lpresto_types$FeatureCode$ = new $c_Lpresto_types$FeatureCode$();
  }
  return $n_Lpresto_types$FeatureCode$;
}
export { $m_Lpresto_types$FeatureCode$ as $m_Lpresto_types$FeatureCode$ };
//# sourceMappingURL=presto.types$-Feature-Code$.js.map
